import styled from 'styled-components'

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const StoreItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const Separator = styled.span`
  margin: 0 ${props => props.theme.spacing.sp4};
`
